// extracted by mini-css-extract-plugin
export default {"section":"or-z","inSectionButton":"pr-z","addressCard":"qr-z","disabled":"rr-z","cautionBox":"sr-z","failureBox":"tr-z","fade-out":"ur-z","successBox":"vr-z"};